import React from 'react';
import './transaction-details-table.scss';

export interface ITransactionDetails {
  fromName: string;
  fromHash: string;
  toName: string;
  toHash: string;
  transactionType: 'sale' | 'issue' | 'purchase';
}

export default function TransactionDetailsTable({
  fromName,
  fromHash,
  toName,
  toHash,
  transactionType,
}: ITransactionDetails) {
  return (
    <table className="transaction-details-table">
      <thead>
        <tr>
          <th className="transaction-details-table__head-item">
            <span className="p p_font-size_14 p_color_cold">Сторона</span>
          </th>
          <th className="transaction-details-table__head-item">
            <span className="p p_font-size_14 p_color_cold">
              Уникальный адрес
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="transaction-details-table__row-item">
            <span className="p p_font-size_12 p_color_light-grey">
              {transactionType === 'sale' || transactionType === 'purchase'
                ? 'Продавец'
                : 'Эмитент'}
            </span>
            <span className="p">{fromName}</span>
          </td>
          <td className="transaction-details-table__row-item">
            <span className="p p_font-size_12 p_color_light-grey">
              {transactionType === 'sale' || transactionType === 'purchase'
                ? 'Адрес продавца'
                : 'Адрес эмитента'}
            </span>
            <span className="p">{fromHash}</span>
          </td>
        </tr>
        <tr>
          <td className="transaction-details-table__row-item">
            <span className="p p_font-size_12 p_color_light-grey">
              {transactionType === 'sale' || transactionType === 'purchase'
                ? 'Покупатель'
                : 'Приобретатель'}
            </span>
            <span className="p">{toName}</span>
          </td>
          <td className="transaction-details-table__row-item">
            <span className="p p_font-size_12 p_color_light-grey">
              {transactionType === 'sale' || transactionType === 'purchase'
                ? 'Адрес покупателя'
                : 'Адрес приобретателя'}
            </span>
            <span className="p">{toHash}</span>
          </td>
        </tr>
      </tbody>
    </table>
  );
}
